import { render, staticRenderFns } from "./TheAccessLogger.vue?vue&type=template&id=3bbf1025&scoped=true&lang=html"
import script from "./TheAccessLogger.vue?vue&type=script&lang=ts"
export * from "./TheAccessLogger.vue?vue&type=script&lang=ts"
import style0 from "./TheAccessLogger.vue?vue&type=style&index=0&id=3bbf1025&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbf1025",
  null
  
)

export default component.exports